import axios from "axios";
import { Toast } from "vant";
import { getToken } from "@/dingLoginUtil/CockpitLogin";
import Vue from 'vue';

let request_num = 0;
let getBaseUrl = "";
let env= ''
const host = window.location.host;

if (host.indexOf('paddl.test.classba.cn') > -1) { // 测试环境
  getBaseUrl = 'https://agent-api-test.classba.cn/agentmanageopenapi';
  env = 'test'
} else if (host.indexOf('exp4pad-pre.classba.cn') > -1) { // 预发环境
  getBaseUrl = 'https://agent-api-pre.classba.cn/agentmanageopenapi';
  env = 'pre'
} else if (host.indexOf('exp4pad.classba.cn') > -1) { // 正式环境
  getBaseUrl = 'https://agent-api.classba.cn/agentmanageopenapi';
  env = 'prod'
} else {
  env = 'dev'
  // getBaseUrl = 'http://oe.zc.dev.myyixue.com/agentmanageopenapi';
  getBaseUrl = 'https://agent-api-test.classba.cn/agentmanageopenapi';
  // getBaseUrl = 'https://agent-api-test.classba.cn/agentmanageopenapi';
  // getBaseUrl = 'http://192.168.31.152:8081';

}

axios.defaults.withCredentials = false;
const service = axios.create({
  baseURL: getBaseUrl,
  withCredentials: false,
  timeout: 10 * 1000, // request timeout
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});
service.interceptors.request.use(
  function (config) {
    // 灰度请求头添加token与dingUserId   "grayValue" 0未灰度 1灰度 2全量
    if (window.$LoginInfo && window.$LoginInfo.getLoginInfo().grayValue !== 0) config.headers.authorization = window.$LoginInfo.getToken() || '';
    if (window.$LoginInfo && window.$LoginInfo.getLoginInfo().grayValue !== 2) config.headers.grayKey = window.$LoginInfo.getDingUserId() || ''; // 全量不传dingUserId
    return Promise.resolve(config);
  },
  function (error) {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  async (response) => {
    console.log(request_num, '接口请求返回response>>>>>>>>>>', response);
    if (response.data.code === -1 && request_num < 3 && window.$LoginInfo) { // 当token丢失或者过期时，重新获取token
      request_num += 1;
      const refreshConfig = { // 重新请求的Config
        baseURL: response.config.baseURL,
        url: response.config.url,
        method: 'post',
        data: JSON.parse(response.config.data || '{}'),
      };
      await getToken(Vue.prototype.$routerConfig.meta.subApplicationId);
      const refreshRes = await service(refreshConfig);
      return Promise.resolve(refreshRes);
    }
    let retData;
    if (response.data.code < 0) {
      retData = {
        ...response.data,
        //  message: '系统开小差了，刷新后再试'
      };
    } else {
      retData = {
        ...response.data,
      };
    }
    return Promise.resolve(retData);
  },
  (error) => {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

class AccountAxios {
  constructor(options = {}) {
    this.options = options;
  }
  request(options) {
    return service.request(options);
  }
  get(url, options = {}) {
    return this.request({
      url: url,
      params: {
        ...options,
      },
    });
  }
  post(url, data, options = {}) {
    if (data instanceof Object) {
      data = JSON.stringify(data);
    }
    return this.request({
      method: "post",
      url,
      data,
      ...options,
    });
  }
}
const instanceAxios = new AccountAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);

export {
  env
}